export default {
    MONTHS: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ],

    MONTHS_SHORT: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],

    // Permission khusus - disimpan sebagai string karena penyocokan dengan string
    PERM_EDIT_INVENTORY: "1001",
    PERM_DOWNLOAD_EXCEL_STOCK: "300",
    PERM_MOVE_INVENTORY: "400",
    PERM_REQUEST_RESET_INVENTORY: "900",
    PERM_EDIT_TABLEAU: "1401",

    isAllowed(code) {
        if (localStorage.getItem("roleId") == 1) {
            return true;
        } else {
            return localStorage
                .getItem("permissions")
                .split(",")
                .includes(code);
        }
    },

    getBasePagedQuery(page, size) {
        let string = "?page=" + page + "&perPage=" + size;
        return string;
    },

    getBaseSortQuery(sort, modifyName = true) {
        let query = "";
        if (sort.by == "nama" && modifyName) {
            query = "name";
        } else {
            query = sort.by;
        }

        return `&sortBy=${query}&asc=${!sort.desc}`;
    },

    parseDate(date, useShortMonth = false) {
        if (this.isBlank(date) || date == "null") {
            return "-";
        }

        const month_names = [
            "Januari",
            "Februari",
            "Maret",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Agustus",
            "September",
            "Oktober",
            "November",
            "Desember"
        ];

        let year = date.slice(0, 4);
        let month = date.slice(5, 7);
        let day = date.slice(8, 10);
        let dayInt = parseInt(day, 10);
        let monthInt = parseInt(month, 10);

        let monthString = useShortMonth
            ? this.MONTHS_SHORT[monthInt - 1]
            : this.MONTHS[monthInt - 1];

        return `${dayInt} ${monthString} ${year}`;
    },

    parseHourMinute(date) {
        if (date) {
            return date.slice(11, 16);
        }

        return "-";
    },

    setFlash(msg) {
        localStorage.setItem("flash", msg);
    },

    getFlash() {
        let flash = localStorage.getItem("flash");
        localStorage.removeItem("flash");
        return flash;
    },

    toastFlash(vue) {
        let flash = this.getFlash();
        if (flash != null) {
            this.toastSuccess(vue, flash);
        }
    },

    toastSuccess(vue, msg, toastTitle = "Sukses") {
        vue.$bvToast.toast(msg, {
            title: toastTitle,
            autoHideDelay: 5000,
            appendToast: true,
            variant: "success"
        });
    },

    toastError(vue, msg, toastTitle = "Gagal") {
        vue.$bvToast.toast(msg, {
            title: toastTitle,
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger"
        });
    },

    parseError(vue, error, toastTitle = "Gagal") {

        if (error.response.status == 401) {
            return;
        }

        let message = "";

        if (typeof error.response.data.error === "object") {
            for (const key in error.response.data.error) {
                let value = error.response.data.error[key];


                message = value[0]
            }
        }

        if (typeof error.response.data.error === "string") {
            message = error.response.data.error;
        }

        this.toastError(vue, message, toastTitle);
    },

    isBlank(input) {
        return input == null || input == "";
    },

    printPayload(payload) {
        for (var pair of payload.entries()) {
            console.log(pair[0] + ": " + pair[1]);
        }
    },

    getRoleId() {
        return Number(localStorage.getItem("roleId"));
    },

    getBlankFile() {
        return "EMPTY-FILE";
    },

    async toBase64(file) {
        let res = await new Promise(resolve => {
            let fileReader = new FileReader();
            fileReader.onload = e => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });

        return res;
    },

    formatThousand(x, returnIfNull = "-") {
        if (x == undefined || x == null) {
            return returnIfNull;
        }

        return x.toLocaleString("de-DE", { maximumFractionDigits: 0 });
        // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".")
    },

    toNumber(str, returnIfNull = "-", blankReturnsNull = false) {
        if (str == undefined || str == null) {
            return returnIfNull;
        }

        if (blankReturnsNull && str == "") {
            return returnIfNull;
        }

        if (str == "") {
            return 0;
        }

        return Number(str.replace(/\./g, ""));
    },

    async readBase64(file) {
        if (file == null) return null;

        let res = await new Promise(resolve => {
            let fileReader = new FileReader();
            fileReader.onload = e => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });

        return res;
    },

    checkRoleNumber(number, array) {
        const convertToArray = array.split(",");

        const isFound = convertToArray.some(num => {
            const numAsString = num.toString();
            const numberToString = number.toString();

            return (
                numAsString === numberToString ||
                numAsString.startsWith(numberToString + ",") ||
                numAsString.endsWith("," + numberToString) ||
                numAsString.includes("," + numberToString + ",")
            );
        });

        return isFound;
    },

    base64ToFile(base64String, fileName) {
        // Split the base64 string to get the data type and the actual base64 content
        const base64Parts = base64String.split(";base64,");
        const contentType = base64Parts[0].split(":")[1];
        const raw = window.atob(base64Parts[1]);
        const rawLength = raw.length;
        const uint8Array = new Uint8Array(rawLength);

        // Convert the raw binary data to Uint8Array
        for (let i = 0; i < rawLength; ++i) {
            uint8Array[i] = raw.charCodeAt(i);
        }

        // Create a Blob from the Uint8Array
        const blob = new Blob([uint8Array], { type: contentType });

        // Create a File from the Blob
        return new File([blob], fileName, { type: contentType });
    },

    formatDate(date) {
        if (date == null) {
            return "-";
        }

        // with hours minutes and seconds
        return new Date(date).toLocaleString("id-ID", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
    }
};
